export const VesselType ={
    MOTOR: 'MOTOR',
    SAIL: 'SAIL',
    WIDEBEAM: 'WIDEBEAM',
    BARGE: 'BARGE',
    NARROWBOAT: 'NARROWBOAT',
    RIB: 'RIB'
}
